import { HttpContext } from '@angular/common/http'
import { ChangeDetectorRef, Component, Inject, Optional, OnInit } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { StartupService, I18NService } from '@core'
import { ReuseTabService } from '@delon/abc/reuse-tab'
import { ALLOW_ANONYMOUS, DA_SERVICE_TOKEN, ITokenService, SocialService } from '@delon/auth'
import { _HttpClient, SettingsService, TitleService, ALAIN_I18N_TOKEN } from '@delon/theme'
import { environment } from '@env/environment'
import { NzTabChangeEvent } from 'ng-zorro-antd/tabs'
import { finalize, interval, take, map, of } from 'rxjs'
const { msUrl } = environment.api

@Component({
  selector: 'passport-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less'],
  providers: [SocialService],
})
export class UserLoginComponent implements OnInit {
  passwordVisible = false
  password?: string
  image_key = ''
  image_src = ''
  constructor(
    private fb: FormBuilder,
    private router: Router,
    @Optional()
    @Inject(ReuseTabService)
    private reuseTabService: ReuseTabService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
    private startupSrv: StartupService,
    private http: _HttpClient,
    private cdr: ChangeDetectorRef,
    private settingService: SettingsService,
    private titleSrv: TitleService,
    @Inject(ALAIN_I18N_TOKEN) protected i18n: I18NService,
  ) {}

  ngOnInit(): void {
    this.getVerificationCode()
    this.titleSrv.setTitle(this.i18n.fanyi('app.login.login'))
  }

  getVerificationCode(): void {
    this.http
      .get(`${msUrl.auth}/captcha/key`, null, {
        context: new HttpContext().set(ALLOW_ANONYMOUS, true),
      })
      .subscribe((res) => {
        if (res.successful) {
          const { message } = res
          this.image_key = message
          this.image_src = `${msUrl.auth}/captcha?key=${message}&_allow_anonymous=true`
        }
      })
  }

  // #region fields
  user = JSON.parse(localStorage.getItem('login') || '{}')
  form = this.fb.nonNullable.group({
    mobile: ['', [Validators.required, Validators.pattern(/^1\d{10}$/)]],
    captcha: ['', [Validators.required]],
    code: ['', [Validators.required]],
    userName: [this.user?.remember ? this.user.userName : '', [Validators.required]],
    password: [this.user?.remember ? this.user.password : '', [Validators.required]],
    remember: [this.user?.remember],
  })
  error = ''
  type = 0
  loading = false
  count = 0

  switch({ index }: NzTabChangeEvent): void {
    this.type = index!
  }

  getCaptcha(): void {
    const mobile = this.form.controls.mobile
    if (mobile.invalid) {
      mobile.markAsDirty({ onlySelf: true })
      mobile.updateValueAndValidity({ onlySelf: true })
      return
    }

    // this.http
    //   .get(`${msUrl.auth}/captcha/key?_allow_anonymous=true`)
    //   .pipe(
    //     map((res) => {
    //       const { successful, message } = res
    //       if (successful) {
    //         return this.http.get(`${msUrl.auth}/captcha/phone?_allow_anonymous=true`, {
    //           phoneNumber: mobile.value,
    //           captchaKey: message,
    //         })
    //       }
    //       return of(res)
    //     }),
    //   )
    //   .subscribe((res: any) => {
    //     const { successful, data } = res
    //     if (successful) {
    //       const { expire } = data
    //       this.count = expire
    //       const numbers = interval(1000)
    //       const takeNumbers = numbers.pipe(take(this.count))
    //       takeNumbers.subscribe((x) => {
    //         this.count = this.count - 1
    //       })
    //     }
    //   })

    this.http
      .get(`${msUrl.auth}/captcha/key`, null, {
        context: new HttpContext().set(ALLOW_ANONYMOUS, true),
      })
      .subscribe((res) => {
        if (res.successful) {
          const { message } = res
          this.http
            .get(
              `${msUrl.auth}/captcha/phone`,
              {
                phoneNumber: mobile.value,
                captchaKey: message,
              },
              {
                context: new HttpContext().set(ALLOW_ANONYMOUS, true),
              },
            )
            .subscribe((res) => {
              if (res.successful) {
                const { data } = res
                const { expire } = data
                this.count = 60 // expire
                const numbers = interval(1000)
                const takeNumbers = numbers.pipe(take(this.count))
                takeNumbers.subscribe((x) => {
                  this.count = this.count - 1
                })
              }
            })
        }
      })
  }

  submit(): void {
    localStorage.setItem('login', JSON.stringify(this.form.value))
    this.error = ''

    // validation
    if (this.type === 1) {
      const { userName, password, code } = this.form.controls
      userName.markAsDirty()
      userName.updateValueAndValidity()
      password.markAsDirty()
      password.updateValueAndValidity()
      code.markAsDirty()
      code.updateValueAndValidity()
      if (userName.invalid || password.invalid || code.invalid) {
        return
      }
    } else {
      const { mobile, captcha } = this.form.controls
      mobile.markAsDirty()
      mobile.updateValueAndValidity()
      captcha.markAsDirty()
      captcha.updateValueAndValidity()
      if (mobile.invalid || captcha.invalid) {
        return
      }
    }

    const preRequest = () => {
      this.loading = true
      this.cdr.detectChanges()
    }

    const afterRequest = () => {
      this.loading = false
      this.cdr.detectChanges()
    }

    preRequest()
    let body = {}

    if (this.type === 0) {
      body = {
        userName: this.form.value.mobile,
        loginType: 'phone',
        captcha: this.form.value.captcha,
      }
    } else if (this.type === 1) {
      body = {
        userName: this.form.value.userName,
        password: this.form.value.password,
        loginType: 'account',
        captcha: this.form.value.code,
        captchaKey: this.image_key,
      }
    }

    const options = {
      context: new HttpContext().set(ALLOW_ANONYMOUS, true),
    }

    this.http
      .post(`${msUrl.auth}/login`, body, null, options)
      .pipe(finalize(afterRequest))
      .subscribe((res) => {
        const { successful, code } = res
        if (!successful) {
          //this.error = res.message
          this.cdr.detectChanges()
          if (code == '403') {
            this.getVerificationCode()
          }
          return
        }

        const { access_token, data } = res
        // 清空路由复用信息
        this.reuseTabService.clear()
        this.tokenService.set({ token: `Bearer ${access_token}` })
        this.settingService.setUser(data)
        // 重新获取 StartupService 内容，我们始终认为应用信息一般都会受当前用户授权范围而影响
        this.startupSrv.load().subscribe(() => {
          let url = this.tokenService.referrer!.url || '/'
          if (url.includes('/passport')) {
            url = '/'
          }
          this.router.navigateByUrl(url)
        })
      })
  }
}
